import script from "./AcademyArticle3.vue?vue&type=script&setup=true&lang=js"
export * from "./AcademyArticle3.vue?vue&type=script&setup=true&lang=js"

import "./AcademyArticle3.vue?vue&type=style&index=0&id=47d76afa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47d76afa"]])

export default __exports__